import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-wppsi-processing-speed-index',
    templateUrl: './wppsi-processing-speed-index.component.html',
    styleUrls: ['./wppsi-processing-speed-index.component.scss']
})
export class WppsiProcessingSpeedIndexComponent implements OnInit, OnDestroy {

    constructor(
        private http: HttpService,
        public loading: LoadingService,
        private location: Location
    ) { }
    data: any[] = [];
    numberOfQuiz: number = 1;
    totalQuiz: number = 0;
    percentQuiz: string = '0';
    currentQuiz: any = {};
    currentQuestion: any = {};
    currentAnswer: any[] = [];
    assetUrl: any = null;
    point: number = 0;
    elapsedTime: number = 0;
    isDone: boolean = false;
    startTime: number = 0;
    endTime: number = 0;
    countDownInterval: any = null;
    countDown: number = 3;
    graphImage: any = null;
    timeOutQuiz: number = 5000; // in miliseconds
    currentTimeOut: number = 0;
    timeOutInterval: any = null;
    percentTimeOut: any = '0';
    nextTimeout: any = null;

    async getData(): Promise<void> {
        const r = await this.http.Get('quiz/wppsi/processing-speed-index', {}, true);
        if (!r.success) {
            this.location.back();
            return;
        }
        this.data = r.response?.result?.data || [];
        this.graphImage = r.response?.result?.image || null;
        this.totalQuiz = this.data.length || 1;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.loading.done();
        this.countDownInterval = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
                this.playQuiz();
                clearInterval(this.countDownInterval);
            }
        }, 1000);
    }

    playQuiz(): void {
        this.startTime = (new Date()).getTime();
        this.currentQuiz = this.data[this.numberOfQuiz - 1];
        this.currentQuestion = { image: this.currentQuiz.question };
        this.currentAnswer = this.currentQuiz?.details?.filter((e: any) => !e.is_true);
        this.currentAnswer.push(this.currentQuiz?.details?.find((e: any) => e.is_true));
        this.currentAnswer.sort(() => Math.random() - 0.5);
        this.playAudio();
        clearInterval(this.timeOutInterval);
        this.currentTimeOut = 0;
        this.timeOutInterval = setInterval(() => {
            if (this.currentTimeOut < this.timeOutQuiz) {
                this.currentTimeOut += 100;
            } else {
                clearInterval(this.timeOutInterval);
            }
            this.percentTimeOut = ((this.currentTimeOut / this.timeOutQuiz) * 100).toFixed(0);
        }, 100);
        this.nextTimeout = setTimeout(() => {
            this.nextQuiz();
        }, this.timeOutQuiz);
    }

    nextQuiz(): void {
        this.endTime = (new Date()).getTime();
        this.elapsedTime += (this.endTime - this.startTime);
        clearTimeout(this.nextTimeout);
        if (this.numberOfQuiz >= this.totalQuiz) {
            this.isDone = true;
            this.postResult();
            return;
        }
        this.numberOfQuiz++;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.playQuiz();
    }

    playAudio(): void {
        if (!this.currentQuiz.voice) {
            return;
        }
        let audio = new Audio(this.assetUrl + this.currentQuiz.voice);
        audio.play();
    }

    answerQuiz(item: any): void {
        if (this.isDone) {
            this.postResult();
            return;
        }
        this.point += (item.is_true ? this.currentQuiz.point : 0);
        this.nextQuiz();
    }

    async postResult(): Promise<void> {
        let seconds = this.elapsedTime;
        let d = new Date(0);
        d.setMilliseconds(seconds);
        let ts = d.toISOString().substring(11, 23) + '000';
        this.http.SaveQuiz('WPPSI', 'Processing Speed Index', this.point, ts);
    }

    ngOnInit(): void {
        this.loading.start();
        this.assetUrl = environment.assetUrl;
        this.getData();
    }

    ngOnDestroy(): void {
        clearInterval(this.countDownInterval);
        clearTimeout(this.nextTimeout);
        clearInterval(this.timeOutInterval);
    }

}
